import { AbpHttpInterceptor } from '@abp/abpHttpInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.VideosServiceProxy,
        ApiServiceProxies.GameTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.GameTargetAudiencesServiceProxy,
        ApiServiceProxies.GamePlayHistorysServiceProxy,
        ApiServiceProxies.PlayerTicketsServiceProxy,
        ApiServiceProxies.GameInfosServiceProxy,
        ApiServiceProxies.SocialMessagesServiceProxy,
        ApiServiceProxies.AutoReplySettingsServiceProxy,
        ApiServiceProxies.RewardsServiceProxy,
        ApiServiceProxies.GameRewardsServiceProxy,
        ApiServiceProxies.SubmittedSOsServiceProxy,
        ApiServiceProxies.OutletUpdateHistorysServiceProxy,
        ApiServiceProxies.OutletInfoDetailsServiceProxy,
        ApiServiceProxies.OutletInfosServiceProxy,
        ApiServiceProxies.OutletInfomationPhoneServiceProxy,
        ApiServiceProxies.ShopperInfosServiceProxy,
        ApiServiceProxies.PublishersServiceProxy,
        ApiServiceProxies.SurveyTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.GiftCampaignTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.GameSettingsServiceProxy,
        ApiServiceProxies.OutletRevenueBaselinesServiceProxy,
        ApiServiceProxies.BeatPlanHeadersServiceProxy,
        ApiServiceProxies.BeatPlanResultsServiceProxy,
        ApiServiceProxies.ReferralTransactionsServiceProxy,
        ApiServiceProxies.GeneratedVouchersServiceProxy,
        ApiServiceProxies.ArticleUsersServiceProxy,
        ApiServiceProxies.VoucherBudgetsServiceProxy,
        ApiServiceProxies.SalesInvoiceBaselinesServiceProxy,
        ApiServiceProxies.VoucherTransactionLogsServiceProxy,
        ApiServiceProxies.SurveyTicketDetailsServiceProxy,
        ApiServiceProxies.RatingTicketsServiceProxy,
        ApiServiceProxies.QATicketsServiceProxy,
        ApiServiceProxies.TargetAudienceUsersServiceProxy,
        ApiServiceProxies.TargetAudienceDetailsServiceProxy,
        ApiServiceProxies.TargetAudienceHeadersServiceProxy,
        ApiServiceProxies.UserLoginsServiceProxy,
        ApiServiceProxies.ProductsServiceProxy,
        ApiServiceProxies.TerminalMastersServiceProxy,
        ApiServiceProxies.PublisherMastersServiceProxy,
        ApiServiceProxies.VoucherTransactionsServiceProxy,
        ApiServiceProxies.VoucherPatternsServiceProxy,
        ApiServiceProxies.VoucherGroupsServiceProxy,
        ApiServiceProxies.CommunicationTransactionsServiceProxy,
        ApiServiceProxies.CommunicationUsersServiceProxy,
        ApiServiceProxies.CommunicationsServiceProxy,
        ApiServiceProxies.PaymentTransactionsServiceProxy,
        ApiServiceProxies.LogsServiceProxy,
        ApiServiceProxies.TemplatesServiceProxy,
        ApiServiceProxies.ChannelConfigsServiceProxy,
        ApiServiceProxies.ChannelsServiceProxy,
        ApiServiceProxies.SalesInvoiceHeadersServiceProxy,
        ApiServiceProxies.SalesInvoiceDetailsServiceProxy,
        ApiServiceProxies.MasterHeadersServiceProxy,
        ApiServiceProxies.MasterDetailsServiceProxy,
        ApiServiceProxies.BroadcastCategoryServiceProxy,
        ApiServiceProxies.ConsumerProfilesServiceProxy,
        ApiServiceProxies.ConsumerActivitiesServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.ImportServiceProxy,
        ApiServiceProxies.WebHookServiceServiceProxy,
        ApiServiceProxies.SurveySettingsServiceProxy,
        ApiServiceProxies.QuartzHistoryServiceServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.AlbumServiceProxy,
        ApiServiceProxies.FAQServiceProxy,
        ApiServiceProxies.ArticleServiceProxy,
        ApiServiceProxies.VoucherReportServiceProxy,
        ApiServiceProxies.RewardTargetAudiencesServiceProxy,
        ApiServiceProxies.SalesmansServiceProxy,
        ApiServiceProxies.BeatPlanDetailsServiceProxy,
        ApiServiceProxies.GiftCampaignTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.GiftCampaignTargetAudiencesServiceProxy,
        ApiServiceProxies.GiftCampaignsServiceProxy,
        ApiServiceProxies.GiftCampaignsReportServiceProxy,
        ApiServiceProxies.GiftMastersServiceProxy,
        ApiServiceProxies.SurveyInfosServiceProxy,
        ApiServiceProxies.GeneratorHeadersServiceProxy,
        ApiServiceProxies.SurveyResponsesServiceProxy,
        ApiServiceProxies.ReferralBaseLinesServiceProxy,
        ApiServiceProxies.ReferralsServiceProxy,
        ApiServiceProxies.EventSubscriptionDetailsServiceProxy,
        ApiServiceProxies.EventSubscriptionHeadersServiceProxy,
        ApiServiceProxies.ActionsServiceProxy,
        ApiServiceProxies.TransactionsServiceProxy,
        ApiServiceProxies.SecondaryCustomersServiceProxy,
        ApiServiceProxies.RankCalculationSettingsServiceProxy,
        ApiServiceProxies.RankTypesServiceProxy,
        ApiServiceProxies.RanksServiceProxy,
        ApiServiceProxies.SpecialSettingsServiceProxy,
        ApiServiceProxies.ProductSettingsServiceProxy,
        ApiServiceProxies.BaseSettingsServiceProxy,
        ApiServiceProxies.SystemSettingsServiceProxy,
        ApiServiceProxies.FormulaSettingsServiceProxy,
        ApiServiceProxies.ReasonSettingsServiceProxy,
        ApiServiceProxies.RankSettingsServiceProxy,
        ApiServiceProxies.EventSettingsServiceProxy,
        ApiServiceProxies.KindsServiceProxy,
        ApiServiceProxies.SettingParamsServiceProxy,
        ApiServiceProxies.SecondaryCustomerTypesServiceProxy,
        ApiServiceProxies.ChannelTypesServiceProxy,
        ApiServiceProxies.CustomersServiceProxy,
        ApiServiceProxies.DeparmentsServiceProxy,
        ApiServiceProxies.SalesRegionsServiceProxy,
        ApiServiceProxies.RegionsServiceProxy,
        ApiServiceProxies.CampaignsServiceProxy,
        ApiServiceProxies.ProductCategoriesServiceProxy,
        ApiServiceProxies.ProductsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.RankTargetsServiceProxy,
        ApiServiceProxies.TargetAudiencesServiceProxy,
        ApiServiceProxies.CampaignSettingsServiceProxy,
        ApiServiceProxies.GiftInforsServiceProxy,
        ApiServiceProxies.EGiftInforsServiceProxy,
        ApiServiceProxies.GiftCategoryServiceProxy,
        ApiServiceProxies.GiftGroupsServiceProxy,
        ApiServiceProxies.GiftGroupDetailsServiceProxy,
        ApiServiceProxies.ActionRulesServiceProxy,
        ApiServiceProxies.SenioritySettingsServiceProxy,
        ApiServiceProxies.ImportServiceProxy,
        ApiServiceProxies.WebHookSubscriptionInfoServiceProxy,
        ApiServiceProxies.WebHookServiceServiceProxy,
        ApiServiceProxies.MemberActivityRuleServiceProxy,
        ApiServiceProxies.TransactionDetailsServiceProxy,
        ApiServiceProxies.GiftRedeemTransactionsServiceProxy,
        ApiServiceProxies.AdjustmentFileStatusServiceProxy,
        ApiServiceProxies.UploadedInvoicesServiceProxy,
        ApiServiceProxies.SurveyAnswersServiceProxy,
        ApiServiceProxies.ConsumerDbProductsServiceProxy,
        ApiServiceProxies.GameInforsServiceProxy,
        ApiServiceProxies.QuestServiceProxy,
        ApiServiceProxies.MissionServiceProxy,
        ApiServiceProxies.QuestGroupServiceProxy,
        ApiServiceProxies.CampaignInfosServiceProxy,
        ApiServiceProxies.CampaignConditionsServiceProxy,
        ApiServiceProxies.CampaignWorkshiftInfosServiceProxy,
        ApiServiceProxies.TagServiceProxy,
        ApiServiceProxies.SocialSurveyInfosServiceProxy,
        ApiServiceProxies.SurveySettingsServiceProxy,
        ApiServiceProxies.SurveyInfosServiceProxy,
        ApiServiceProxies.SurveyTargetAudiencesServiceProxy,
        ApiServiceProxies.SurveyQuestionsServiceProxy,
        ApiServiceProxies.PosmServiceProxy,
        ApiServiceProxies.ConsumerLoginsServiceProxy,
        ApiServiceProxies.SurveyResponsesServiceProxy,
        ApiServiceProxies.RequestServiceProxy,
        ApiServiceProxies.PayBonussServiceProxy,
        ApiServiceProxies.SalesTargetActualServiceProxy,
        ApiServiceProxies.SalesTargetHeaderServiceProxy,
        ApiServiceProxies.ProgramActualServiceProxy,
        ApiServiceProxies.ProgramTargetServiceProxy,
        ApiServiceProxies.ProgramServiceProxy,
        ApiServiceProxies.BrandActualServiceProxy,
        ApiServiceProxies.BrandServiceProxy,
        ApiServiceProxies.ConversationStatusesServiceProxy,
        ApiServiceProxies.CommunicationTargetAudiencesServiceProxy,
        ApiServiceProxies.SocialSurveyTargetAudiencesServiceProxy,
        ApiServiceProxies.VendorSettingsServiceProxy,
        ApiServiceProxies.ConsentReportsServiceProxy,
        ApiServiceProxies.RankHistoriesServiceProxy,
        ApiServiceProxies.ArticleTargetAudiencesServiceProxy,
        ApiServiceProxies.ArticleTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.SaleOrderServiceProxy,
        ApiServiceProxies.SaleOrderDetailServiceProxy,
        ApiServiceProxies.SalesServiceProxy,
        ApiServiceProxies.SAPSerialsServiceProxy,
        ApiServiceProxies.TaskManagementServiceProxy,
        ApiServiceProxies.GiftTargetAudiencesServiceProxy,
        ApiServiceProxies.TaskInfosServiceProxy,
        ApiServiceProxies.TaskResponsesServiceProxy,
        ApiServiceProxies.TaskTargetAudiencesServiceProxy,
        ApiServiceProxies.TaskAnswersServiceProxy,
        ApiServiceProxies.TaskQuestionsServiceProxy,
        ApiServiceProxies.OutletInfoUpdateHistoryServiceProxy,
        ApiServiceProxies.OneTimePasswordServiceProxy,
        ApiServiceProxies.SaleHistoriesServiceProxy,
        ApiServiceProxies.ChallengeServiceProxy,
        ApiServiceProxies.DeleteProfileRequestsServiceProxy,
        ApiServiceProxies.UpdateProfileRequestHistoryServiceProxy,
        ApiServiceProxies.RegisterWarrantysServiceProxy,
        ApiServiceProxies.SocialSurveyTargetAudienceDetailsServiceProxy,
        ApiServiceProxies.SocialSurveyAnswersServiceProxy,
        ApiServiceProxies.SocialSurveyQuestionsServiceProxy,
        ApiServiceProxies.SocialSurveyResponsesServiceProxy,
        ApiServiceProxies.SurveyTransactionsServiceProxy,
        ApiServiceProxies.ActivationCodeServiceProxy,
        ApiServiceProxies.ExtendActiveSerialServiceProxy,
        ApiServiceProxies.SerialTypeServiceProxy,
        ApiServiceProxies.RedemptionRequestManagementServiceProxy,
        ApiServiceProxies.CampaignManagementServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
